export function buildStudyIframeUrl(params) {
    const url = new URL(params.studyUrl);
    const hash = new URLSearchParams();
    hash.set('campaignHandoffToken', params.campaignHandoffToken);
    hash.set('platform', 'web');
    hash.set('forceFreshSession', params.forceFreshSession ? '1' : '0');
    if (params.presentationMode) {
        hash.set('presentationMode', params.presentationMode);
    }
    if (params.restoredSessionToken) {
        hash.set('restoredSessionToken', params.restoredSessionToken);
    }
    if (params.audio !== undefined) {
        hash.set('audio', params.audio ? '1' : '0');
    }
    url.hash = hash.toString();
    return url.toString();
}
//# sourceMappingURL=context.js.map